import {isNullOrUndefined} from "./commonUtilities";

export function toDangerouslySetHtml(htmlString: string): { __html: string } {
    return { __html: htmlString };
}

export function convertLineBreaksToBreakTags(rawString: string | null | undefined): string {
    if (!rawString)
        return "";

    return rawString.replace(/(?:\r\n|\r|\n)/g, "<br>");
}

export function getRandomInt(min = 1, max = 1000): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function openInNewTab(url: string | null | undefined): void
{
    if(isNullOrUndefined(url))
        return;

    window.open(`${url}`); /* eslint-disable-line */
}
